export enum ICON_TYPE {
  CALENDAR = 'CALENDAR',
  FILTER = 'FILTER',
  SORTING = 'SORTING',
  BROWSE = 'BROWSE',

}
